export * from './bedStatus.service';